<template>
<div style="margin:10px 0 0 10px;">
   <a-pagination show-quick-jumper :defaultPageSize="defaultPageSize" :default-current="current" :total="total" @change="onChange" />
</div>
</template>

<script>
export default {
    data(){
        return{
      
        }
    },
    props:{
        total:{
            type:Number
        },
        current:{
            type:Number,
            default:1
        },
        defaultPageSize:{
            type:Number,
            default:10
        }
    },
    methods:{
        onChange(pageNumber){
            this.$emit("getList",pageNumber)
        }
    }
}
</script>

<style>

</style>